import React from 'react';
import { useUpdateChecker } from '../hooks/useUpdateChecker';

const UpdateBanner = () => {
  
  const { updateAvailable, reload } = useUpdateChecker();
  
  if (!updateAvailable) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[99999] animate-fade-in">
      <div className="relative overflow-hidden rounded-xl shadow-lg px-5 py-3 flex items-center gap-4 bg-gradient-to-r from-azul-surelia to-azul-surelia/90">
        <div className="absolute -right-4 -top-4 w-24 h-24 bg-verde-lima/20 rounded-full blur-2xl"></div>
        <div className="absolute -left-2 -bottom-2 w-16 h-16 bg-cian-digital/15 rounded-full blur-xl"></div>
        <p className="relative text-sm font-medium text-white">
          Hay una nueva versión disponible
        </p>
        <button
          onClick={reload}
          className="relative whitespace-nowrap px-4 py-1.5 bg-verde-lima rounded-lg text-azul-surelia text-sm font-semibold hover:bg-verde-lima/90 transition-all duration-200"
        >
          Actualizar
        </button>
      </div>
    </div>
  );
};

export default UpdateBanner;
